<script lang="ts">
  import Swal from 'sweetalert2';
  import Dialog from '@/components/dialog/Dialog.svelte';
  import {DateInput} from 'date-picker-svelte';
  import {UserService} from '@/services';
  import {createEventDispatcher} from 'svelte';

  // Props
  export let user: any;
  export let isTrialDialogOpen = false;

  const dispatch = createEventDispatcher();

  // Local Variables
  let isAddingRecord = false;
  let expiresAt: Date = new Date();
  let maxDate: Date = new Date();
  let maxValue: Date = new Date(maxDate.setFullYear(maxDate.getFullYear() + 1));

  let userService = new UserService();

  $: isTrialDialogOpen = false;

  async function addTrial() {
    if (!user) return console.log('User not Defined');

    isAddingRecord = true;

    userService
      .addTrial({
        owner: user,
        expiresAt: expiresAt
      })
      .then(() => {
        dispatch('reload-user-data', {owner: user});
        Swal.fire({
          title: 'Added Trial for User',
          icon: 'success',
          timer: 500,
          timerProgressBar: true
        });
      })
      .catch(error => {
        console.error('delete error', error);
        Swal.fire({
          position: 'bottom-end',
          icon: 'error',
          title: 'Failed to Enable Trial',
          showConfirmButton: false,
          timer: 1500,
          toast: true
        });
      })
      .finally(() => {
        isAddingRecord = false;
        isTrialDialogOpen = false;
      });
  }
</script>

<Dialog bind:isDialogOpen={isTrialDialogOpen} useIfShow={true}>
  <div class="pointer-events-none flex h-full w-full items-end justify-center lg:items-center">
    <div
      class="pointer-events-auto h-auto w-full min-w-[280px] rounded-2xl border border-zinc-400 bg-white shadow-lg dark:border-zinc-600 dark:bg-zinc-700 lg:max-w-[680px]"
    >
      <div class="flex items-center p-6 text-zinc-900 dark:text-zinc-200">
        <div class="flex items-center gap-3 py-1.5">
          <div class="flex items-center rounded-full bg-rose-500 p-2 px-2 font-bold text-zinc-100">
            <i class="fa-solid fa-pen"></i>
          </div>
          <h1 class="text-3xl font-bold text-rose-500 dark:text-rose-500">Enable Full Access</h1>
        </div>
        <button
          on:click={() => (isTrialDialogOpen = false)}
          class="ml-auto mr-2 rounded-lg hover:bg-zinc-100 dark:hover:bg-zinc-600"
        >
          <i class="fa-solid fa-x"></i>
        </button>
      </div>
      <hr class="border dark:border-zinc-600" />
      <div class="grid p-6">
        <div class="py-2">
          <label for="name" class="block text-sm font-medium text-gray-800 dark:text-zinc-200">Expiry Date</label>
          <div class="flex pt-2">
            <DateInput bind:value={expiresAt} format={'yyyy-MM-dd HH:mm:ss'} max={maxValue} />
          </div>
        </div>
      </div>
      <hr class="border dark:border-zinc-600" />
      <div class="flex justify-end gap-2 p-6">
        <button
          on:click={() => (isTrialDialogOpen = false)}
          class="{isAddingRecord
            ? 'bg-zinc-100'
            : 'border border-2 border-zinc-400'} flex w-full items-center rounded-md px-3 py-2 font-medium text-zinc-400 lg:w-auto"
          disabled={isAddingRecord}
        >
          <span>Cancel</span>
        </button>
        <button
          on:click={() => addTrial()}
          class="flex w-full items-center gap-1 rounded-md bg-rose-500 px-3 py-2 font-medium text-zinc-100 hover:bg-rose-600 lg:w-auto"
          disabled={isAddingRecord}
        >
          <div
            class="{isAddingRecord
              ? ''
              : 'hidden'} spinner h-4 w-4 !border-zinc-100 !border-t-rose-500 dark:!border-zinc-700 dark:!border-t-rose-500"
          ></div>
          <i class="{isAddingRecord ? 'hidden' : ''} fa-solid fa-floppy-disk" />
          <span>Save</span>
        </button>
      </div>
    </div>
  </div>
</Dialog>
